export default __webpack_public_path__ + "static/media/43.8def3f4c.jpg";